export default {
  loadingConfirmation (state) {
    return state.loadingConfirmation
  },
  logoProviderConfirmation (state) {
    return state.logoProviderConfirmation === '' ? '' : state.logoProviderConfirmation
  },
  detailsScheduled (state) {
    return state.details
  },
  typeConfirmation: (state) => state.type
}



// WEBPACK FOOTER //
// ./src/store/hotsite/confirmacao/getters.js